import { mapControl } from '@/constants';
import { vuexEventPathGenerator } from '@/utils';
import { barogoHQLatLng } from '@/constants/global';
const getterType = {
    getterGetHubByLoginUser: 'getterGetHubByLoginUser',
    getterIsSubscribeHub: 'getterIsSubscribeHub',
    getterIsRepresentativeHub: 'getterIsRepresentativeHub',
    getterSubscribeHub: 'getterSubscribeHub',
    getterSubscribeHubId: 'getterSubscribeHubId',
    getterSubscribeOnlyHubId: 'getterSubscribeOnlyHubId',
    getterSubscribeOnlyDistId: 'getterSubscribeOnlyDistId',
    getterSubscribeHubName: 'getterSubscribeHubName',
    getterSubscribeDistributorHubId: 'getterSubscribeDistributorHubId',
    getterisHubSelectorDisabled: 'getterisHubSelectorDisabled',
    getterIsHubsHasSelectedHub: 'getterIsHubsHasSelectedHub',
    getterAgencyHubList: 'getterAgencyHubList',
    getterSubscribeHubCoordinate: 'getterSubscribeHubCoordinate',
    getterSelectedHubInfo: 'getterSelectedHubInfo',
};
export const hubSelectorGetterType = vuexEventPathGenerator(getterType, 'hubSelector');
const getter = {
    /**
     * 현재 로그인한 유저의 허브를 조회한다.
     */
    [getterType.getterGetHubByLoginUser]: (state, getters, rootState, rootGetters) => {
        const hubId = rootGetters['user/hubId'];
        const filtered = state.hubs.filter((info) => info.value.id === hubId)[0];
        return filtered;
    },
    /**
     * 지도관제시 현재 선택된 허브가 허브인지 총판인지 판단
     * @param {*} state
     * @returns
     */
    [getterType.getterIsSubscribeHub]: (state) => state.subscribeHubInfo[0]?.type === mapControl.HUB,
    // 현재 선택된 허브가 대표허브인지 여부
    getterIsRepresentativeHub: (state, getters, rootState, rootGetters) => {
        const isDistUser = rootGetters['user/isDistUser'];
        const hubId = rootGetters['user/hubId'];
        if (!isDistUser) {
            return false;
        }
        if (!state.subscribeHubInfo[0]) {
            return false;
        }
        const { id, type } = state.subscribeHubInfo[0];
        return type === mapControl.HUB && id === hubId;
    },
    /**
     * 현재 선택된 허브
     */
    [getterType.getterSubscribeHub]: (state) => (state.tmpSubscribeHubInfo.length > 0
        ? state.tmpSubscribeHubInfo[0]
        : state.subscribeHubInfo[0]),
    /**
     * 허브 선택 상태면 허브, 총판 선택 상태면 총판의 아이디
     * @param state
     * @returns
     */
    [getterType.getterSubscribeHubId]: (state) => {
        const hub = state.tmpSubscribeHubInfo.length > 0
            ? state.tmpSubscribeHubInfo[0]
            : state.subscribeHubInfo[0];
        return hub?.id;
    },
    /**
     * 현재 구독중인 허브 아이디 (총판 선택이어도 허브 아이디를 조회 함)
     * @param {*} state
     * @returns
     */
    [getterType.getterSubscribeOnlyHubId]: (state) => {
        const currentHub = state.tmpSubscribeHubInfo.length > 0
            ? state.tmpSubscribeHubInfo[0]
            : state.subscribeHubInfo[0];
        if (!currentHub) {
            return '';
        }
        if (currentHub.type === 'DIST') {
            return currentHub.hubId;
        }
        return currentHub.id;
    },
    /**
     * 현재 구독중인 총판 아이디
     */
    [getterType.getterSubscribeOnlyDistId]: (state) => {
        const currentHub = state.subscribeHubInfo[0];
        if (!currentHub) {
            return '';
        }
        return currentHub.distributorId;
    },
    /**
     * 현재 구독중인 허브 / 총판 이름
     * @param {*} state
     * @returns
     */
    [getterType.getterSubscribeHubName]: (state) => {
        const filtered = state.hubs.filter((info) => info.value.id === state.subscribeHubInfo[0]?.id)[0];
        return filtered?.text ?? '-';
    },
    /**
     * 현재 구독중인 유저가 총판일 경우 hubId
     * @param {*} state
     * @returns
     */
    [getterType.getterSubscribeDistributorHubId]: (state) => state.subscribeHubInfo[0]?.hubId,
    [getterType.getterisHubSelectorDisabled]: (state) => state.isHubSelectorDisabled,
    [getterType.getterIsHubsHasSelectedHub]: (state, getters) => state.hubs.some(({ value }) => value.id
        === (getters.getterSubscribeDistributorHubId
            ?? getters.getterSubscribeHubId)),
    /**
     * 공유 설정 > 수주 허브 리스트
     * @param state
     */
    [getterType.getterAgencyHubList]: (state) => state.hubs
        .filter((hub) => hub.value.id !== state.subscribeHubInfo[0]?.id)
        .map(({ text, value }) => ({
        text,
        value: value.id,
    })),
    /**
     * 구역 설정 > 선택한 허브의 좌표
     * @param state.subscribeHubCoordinate
     */
    [getterType.getterSubscribeHubCoordinate]: (state) => {
        const { latitude, longitude } = state.coordinate;
        return {
            latitude: latitude ?? barogoHQLatLng[0],
            longitude: longitude ?? barogoHQLatLng[1],
        };
    },
    /**
     * 선택한 허브 정보 조회
     */
    [getterType.getterSelectedHubInfo]: (state) => (hubId) => state.hubs
        .find((hub) => hub.value.id === hubId),
};
export default getter;
